export type OrganizationLegendItem = {
    name: string;
    color: string;
};

export const ORGANIZATION_LEGEND_CONFIG: OrganizationLegendItem[] = [
    { name: 'Horizonte Seguros', color: '#49800B' },
    { name: 'IAPSER', color: '#203C78' },
    { name: 'APPC', color: '#21708B' },
    { name: 'AGCABA', color: '#14857A' }
];

const getLegendDisplayValue = (value: unknown): string => {
    if (!value) return '';

    if (typeof value === 'object') {
        const objectValue = value as { nombre?: unknown; name?: unknown; abreviatura?: unknown };
        return String(objectValue.nombre || objectValue.name || objectValue.abreviatura || '');
    }

    return String(value);
};

const normalizeLegendValue = (value: unknown) =>
    getLegendDisplayValue(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase();

const ORGANIZATION_DISPLAY_ALIASES: Record<string, string> = {
    HORIZONTE: 'Horizonte Seguros',
    'HORIZONTE SEGUROS': 'Horizonte Seguros',
    IAPSER: 'IAPSER',
    APPC: 'APPC',
    'AUTOSEGURO PUBLICO PROVINCIAL CHUBUT': 'APPC',
    AGCABA: 'AGCABA',
    CABA: 'AGCABA',
    'AUTOSEGURO DEL GOBIERNO DE LA CIUDAD AUTONOMA DE BUENOS AIRES': 'AGCABA'
};

export const abbreviateOrganizationName = (value?: unknown): string => {
    const displayValue = getLegendDisplayValue(value);

    if (!displayValue) {
        return '';
    }

    return ORGANIZATION_DISPLAY_ALIASES[normalizeLegendValue(displayValue)] || displayValue;
};

export const isAutoseguro = (value?: unknown): boolean =>
    normalizeLegendValue(value).includes('AUTOSEGURO');

export const resolveOrganizationLegendName = (item: any): string => {
    const rawValue =
        item?.organismo?.organismoCentral?.organizacion?.nombre ||
        item?.establecimiento?.organismo?.organismoCentral?.organizacion?.nombre ||
        item?.datosSimp?.organismo?.organismoCentral?.organizacion?.nombre ||
        item?.contrato?.cliente ||
        item?.cliente ||
        item?.nombreCliente ||
        item?.contrato?.cliente ||
        item?.clienteKey ||
        item?.abreviaturaCliente ||
        item?.organizacion ||
        item?.empresa ||
        '';

    return abbreviateOrganizationName(rawValue);
};
